import { IComponent } from "./IComponent";
import { PageState } from "../services";

const $ = jQuery.noConflict();
export class ModalIFrame implements IComponent {
    private name: string;
    private pageState: PageState;
    private element: Element;
    private modal: JQuery<HTMLElement>;
    private modalUrl: string;
    public attach(element: Element, pageState: PageState, previousState) {
        this.name = $(element).data("modal-name");
        pageState.bus.subscribe(this.name, this.busCallback);

        this.element = element;

        this.modal = $(
            `<div class='ui modal modaliframe'>
                <div class="header"></div>
                <div class="scrolling content"></div>
                <div class="actions">
                    <div class="ui button close">Close</div>
                </div>
             </div>`)
            .appendTo(this.element)
            .modal({
                onShow: () => {
                    $(".content", this.modal).empty();
                    $(`<iframe src="${this.modalUrl}">`)
                        .appendTo($(".content", this.modal))
                        .on("load", (ev) => {
                            // console.log('iframe loaded');
                            var height = $(ev.target).contents().height() + 10;
                            var title = $(ev.target).contents().find("title").text();

                            $(".header", this.modal).text(title);
                            $(ev.target).height(height);
                            this.modal.modal("show");
                        });

                }
            });

        $(".close", this.modal).click(() => {
            this.modal.modal("hide");
        });

        $(`[data-modal-show='${this.name}']`).each((i,e) => {
            $(e).click((ev) => {
                ev.preventDefault();
                this.modalUrl = $(e).attr("href");
                this.modal.modal("show");
            });
        });
    }

    private busCallback = (topic: string, data: any) => {
        // console.log("got event", topic, data);
        switch (data.action) {
            case "show":
                this.modalUrl = data.url;                
                this.modal.modal("show");
                break;
            case "hide":
                break;
            default:
                break;
        }
    }

    public getState() {

    }
}
